import React from 'react'
import { Field } from 'formik'

export const File = props => (
    <>
        {props?.label?.length > 0 && props?.type !== 'hidden' && (
            <>
                <p className="mb-[8px]">
                    {props.label}
                    {props.required && <sup className="text-brand-red">*</sup>}
                </p>
            </>
        )}

        <Field name={props.name}>
            {({ field, form }) => (
                <input
                    type="file"
                    aria-label={props.label}
                    onChange={e => form.setFieldValue(field.name, e.currentTarget.files[0])}
                    isDisabled={form.isSubmitting || props.disabled}
                    {...props}
                />
            )}
        </Field>

        {props?.help?.length > 0 && props?.type !== 'hidden' && (
            <p className="text-brand-grey text-[12px] mb-[15px] md:mb-[30px] mt-[8px]">
                {props.help}
            </p>
        )}
    </>
)
